/**
 * Created by hanan on 16/11/30.
 * 申请借款弹层组件
 */

require('./apply.scss');
require('public/jquery/chosen/chosen.css');
require('public/jquery/chosen/chosen.jquery.js');

var cityMap = {};
var branchMap = {};

function renderSelect(el, list) {
  el.empty().append('<option value="请选择">' + (el.data('placeholder') || '请选择') + '</option>').val('请选择').trigger('change');
  for (var i = 0; i < list.length; i++) {
    el.append('<option value="' + list[i].value + '" data-id="' + list[i].id + '">' + list[i].name + '</option>');
  }
  el.trigger("chosen:updated").trigger('change');
}

class Apply {

  // 构造函数
  constructor() {
    this.msmcodeTimer = null;
    this.locateTimer = null;
    this.applying = false;
    this.render();
    this.bindEvent();
   // this.getProvince();
    this.eventElement = $({});
    //this.captchaCode();
  }


  // 静态方法，新建一个实例
  static create() {
    return new Apply();
  }

  on (type, cb) {
    this.eventElement.on(type, cb);
  }

  trigger (type) {
    this.eventElement.trigger(type);
  }

  // 渲染 dom 节点
  render() {
    this.el = $(`
      <div class="apply-dialog-wrap">
        <img src="/static/common/images/loading.gif" class="waiting">
        <div class="apply-dialog">
          <div class="apply-dialog-top">
            <img class="apply-dialog-top-close" src="${require('./images/close.png')}"/>
            只需10秒钟<br>坐等专业借款顾问为您服务
          </div>
          <form class="apply-dialog-form">
            <div class="item">
              <span>客户姓名</span>
              <input type="text" placeholder="请输入您的姓名" name="name"/>
            </div>
            <div class="item">
              <span>手机号码</span>
              <input placeholder="请输入您的手机号码" name="mobile"/>
            </div>
            <div class="item">
              <span>验证码</span>
              <input class="smscode captchaCode" type="text" placeholder="请输入验证码" name="captchaCode"/>
              <img src="" class="code-img">
            </div>
            <div class="item">
              <span>短信验证码</span>
              <input class="smscode" type="text" placeholder="请输入短信验证码" name="smscode"/>
              <button type="button" class="apply-send-smscode">发送验证码</button>
            </div>
            <div class="item select">
              <span>所在省份</span>
              <select data-placeholder="请选择所在省份" name="provinceCode"> 
                <option value="请选择">请选择所在省份</option>
              </select>
            </div>
            <div class="item select">
              <span>所在城市</span>
              <select data-placeholder="请选择所在城市" name="cityCode">  
                <option value="请选择">请选择所在城市</option>
              </select>
            </div>
            <div class="item select">
              <span>公司门店</span>
              <select data-placeholder="请选择公司门店" name="branchCode">
               <option value="请选择">请选择公司门店</option>
              </select>
            </div>
          </form>
          <div class="apply-dialog-buttom">
            <button type="button" class="apply-confirm disable">立即申请</button>
          </div>
        </div>
      </div>
    `).hide();
    $('body').append(this.el);

  }

  // 事件绑定
  bindEvent() {
    var self = this;

    // 选择省市
    this.el.find('[name=provinceCode]').on('change', function () {
      self.getCity($(this).val());
    });

    // 选择城市
    this.el.find('[name=cityCode]').on('change', function () {
      var opt = $(this).find(':selected');
      self.getBranches(opt.data('id'));
    });

    // 更新下拉文字颜色
    console.log(this.el.find('select'))
    this.el.find('select').on('change', function () {
      var val = $(this).val();
      ($(this).next())[(val === '请选择' ? 'add' : 'remove') + 'Class']('placeholder');
    }).trigger('change');

    // 发送短信验证码按钮
    this.el.find('.apply-send-smscode').on('click', function () {
      self.sendSms();
    });

    // 验证提交按钮是否可点
    this.el.find('select').on('change', function () {
      self.vilidate();
    });
    this.el.find('input').on('keyup', function () {
      self.vilidate();
    });

    // 点击提交按钮
    this.el.find('.apply-confirm').on('click', function () {
      self.apply();
    });

    // 点击关闭按钮
    this.el.find('.apply-dialog-top-close').on('click', function () {
      self.hide();
    });

    //点击图片验证码
    this.el.find('.code-img').on('click', function () {
      self.captchaCode();
    });
    // 改变窗口大小时调整dialog位置
    $(window).on('resize', function () {
      // console.log('resize');
      self.locate();
    });
    
  }

  // 获取省份下拉信息
  getProvince() {
    var provinceList = [];
    var el = this.el.find('[name=provinceCode]');
    var api = 'https://lendapp.finupcredit.com/lend-app/customerOfficialwWebsite/appOfficialwWebsiteController/getCityMethod';
    $.ajax({
      url: api,
      dataType: 'jsonp',
      success: function (result) {
        if (result.length) {
          var items = result[0].items;
          for (var i = 0; i < items.length; i++) {
            var p = items[i];
            if (p.city.length) {
              cityMap[p.name] = p.city;
              provinceList.push({
                name: p.name,
                value: p.name
              });
            }
          }
          renderSelect(el, provinceList);
        }
      }
    });
  }

  // 获取城市下拉信息
  getCity(province) {
    var cityList = [];
    var list = cityMap[province] || [];
    for (var j = 0; j < list.length; j++) {
      cityList.push({
        id: list[j].id,
        name: list[j].cityName,
        value: list[j].cityCode
      });
    }
    renderSelect(this.el.find('[name=cityCode]'), cityList);
  }

  // 获取门店下拉信息
  getBranches(id) {
    var el = this.el.find('[name=branchCode]').empty();
    var api = 'https://lendapp.finupcredit.com/lend-app/customerOfficialwWebsite/appOfficialwWebsiteController/getCityBranchMethod';

    if (!id) {
      return renderSelect(el, []);
    }

    if (branchMap[id]) {
      return renderSelect(el, branchMap[id]);
    }

    $.ajax({
      url: api,
      dataType: 'jsonp',
      data: {
        id: id
      },
      success: function (result) {
        var list = [];
        if (result.length) {
          var items = result[0].items;
          for (var i = 0; i < items.length; i++) {
            list.push({
              name: items[i].branchName,
              value: items[i].branchCode
            });
          }
          branchMap[id] = list;
          renderSelect(el, list);
        }
      }
    });
  }

  // 显示弹层
  show() {
    this.clear();
    this.el.show();
    if (!this._chosen) {
      this._chosen = true;
      this.el.find('select').chosen();
      this.el.find('select').trigger('change');
    }
    this.locate();
    this.captchaCode();
  }

  //位置调整
  locate () {
    const dialog = this.el.find('.apply-dialog');
    this.resizeTimer = setTimeout(() => {
      dialog[dialog.height() > $(window).height() ? 'addClass' : 'removeClass']('top');
    }, 50);
  }

  // 隐藏弹层
  hide() {
    this.el.hide();
    this.clear();
  }

  // 发送验证码
  sendSms() {
    var self = this;
    var btn = this.el.find('.apply-send-smscode');
    var mobile = this.el.find('[name=mobile]').val();
    var captchaCode = this.el.find('[name=captchaCode]').val().toLowerCase();

    if (btn.hasClass('second')) {
      return;
    }

    if (!/^\d{11}$/.test(mobile)) {
      return alert('手机号码格式错误，请重新输入。');
    }

    if(!/^[a-zA-Z0-9]{5}$/.test(captchaCode)){
      return alert('图形验证码不正确！');
    }

    $(btn).addClass('second').text(90);
    self.msmcodeTimer = setInterval(function () {
      var time = btn.text() | 0;
      if (time <= 0) {
        unlock();
      }
      else {
        btn.text(--time);
      }
    }, 1000);

    function unlock() {
      btn.removeClass('second').text('发送验证码')
      clearInterval(self.msmcodeTimer);
    }

    $.ajax({
      url: '/api/smscode',
      type: 'post',
      data: {
        mobile: mobile,
        captchaCode:captchaCode,
      },
      dataType: 'json',
      success: function (data) {

        if (!data.code) {
          unlock();
        }else if(data.code == '-2'){
          unlock();
          alert(data.message);
        }
        // alert(data.message);
      },
      error: function () {
        unlock();
        alert('提示信息', '请求出现错误！');
      }
    });
  }

  // 表单验证
  vilidate() {
    var name = this.el.find('[name=name]').val();
    var mobile = this.el.find('[name=mobile]').val();
    var smscode = this.el.find('[name=smscode]').val();
    var provinceCode = this.el.find('[name=provinceCode]').val();
    var cityCode = this.el.find('[name=cityCode]').val();
    var branchCode = this.el.find('[name=branchCode]').val();
    var btn = this.el.find('.apply-confirm');
    provinceCode = provinceCode == '请选择' ? '' : provinceCode;
    cityCode = cityCode == '请选择' ? '' : cityCode;
    branchCode = branchCode == '请选择' ? '' : branchCode;

    if (name && /^\d{11}$/.test(mobile) && smscode && provinceCode && cityCode && branchCode) {
      btn.removeClass('disable');
    }
    else {
      btn.addClass('disable');
    }
  }

  // 提交申请
  apply() {
    var self = this;
    var btn = this.el.find('.apply-confirm');
    var waiting = this.el.find('.waiting');
    if (!btn.hasClass('disable')) {
      var name = this.el.find('[name=name]').val();
      var mobile = this.el.find('[name=mobile]').val();
      var smscode = this.el.find('[name=smscode]').val();
      var provinceCode = this.el.find('[name=provinceCode]').val();
      var province = this.el.find('[name=provinceCode]').find(':selected').text();
      var cityCode = this.el.find('[name=cityCode]').val();
      var city = this.el.find('[name=cityCode]').find(':selected').text();
      var branchCode = this.el.find('[name=branchCode]').val();
      var branch = this.el.find('[name=branchCode]').find(':selected').text();
      var channel = 3;
      var submitChannel = 'PC';
      var position = 'product'; //'advertisement';

      btn.addClass('disable');
      waiting.show();
      $.ajax({
        url: '/api/apply',
        type: "post",
        dataType: "json",
        data: {name, mobile, smscode, province, provinceCode, city, cityCode, branch, branchCode, channel, submitChannel,position},
        success: function (data) {
          if (data.code == 1) {
            self.clear();
            self.hide();
            self.trigger('apply');
            alert('您的申请已提交。');
          }
          else {
            alert(data.message || data.msg || '申请失败，请重试');
          }
          btn.removeClass('disable');
          waiting.hide();
        },
        error: function () {
          alert('请求出现错误');
          btn.removeClass('disable');
          waiting.hide();
        }
      });
    }
  }

  // 清空表单
  clear() {
    this.el.find('input').val('').trigger('change');
    this.el.find('[name=provinceCode]').val('请选择').trigger("chosen:updated").trigger('change');
  }
  // 获取验证码
  captchaCode() {
    var that = this.el.find('img.code-img');
    $.ajax({
      url: '/api/captcha',
      type: 'post',
      data: {},
      dataType: 'json',
      success: function (data) {
        if (data.code == 1) {
          that.attr("src",data.img);
        }
        // alert(data.message);
      },
      error: function () {
        alert('提示信息', '请求出现错误！');
      }
    });
  }
}

module.exports = Apply;


// WEBPACK FOOTER //
// ./static/common/apply/apply.js